import { queryOptions } from '@tanstack/react-query'

import { api, unwrap } from '@/lib/api/client'

export const authQueries = {
  /** The signed-in user and every org they belong to. Cleared on sign-out, reused across routes. */
  me: () =>
    queryOptions({
      queryKey: ['auth', 'me'] as const,
      queryFn: async () => unwrap(await api.GET('/api/v1/auth/me')),
      staleTime: 5 * 60 * 1000,
      retry: false,
    }),
}
